<ul>
  <li *ngFor="let cargo of cargos">
    <app-assigned-cargo-item-list [cargo]="cargo.averageable"></app-assigned-cargo-item-list>
  </li>
</ul>